import React, { useState } from "react";
import {
  FormControl,
  Grid,
  TextField,
  IconButton,
  Box,
  Modal,
  Tooltip,
  MenuItem,
  Drawer,
  Button,
} from "@mui/material";
import ModalHeader from "./ModalHeader";
import ModalFooter from "./ModalFooter";
import ApiEndpoints from "../network/ApiEndPoints";
import { get, postJsonData } from "../network/ApiController";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  p: 2,
  height: "max-content",
  overflowY: "scroll",
};

const EditVpa = ({ row, refresh }) => {
  const [open, setOpen] = React.useState(false);

  const [request, setRequest] = useState(false);

  const EditVpaModal = (event) => {
    event.preventDefault();

    const data = {
      id: row?.id,
      vpa: `${formData.prefix}@${formData.suffix.replace(/^@/, "")}`,
    };

    setRequest(true);

    postJsonData(
      ApiEndpoints.UPDATE_VPA,
      data,
      setRequest,
      (res) => {
        okSuccessToast(res?.data?.message || res?.message);
        handleClose();
        if (refresh) refresh();
      },
      (error) => {
        apiErrorToast(error);
      },
    );
  };

  const handleOpen = () => {
    setFormData({
      prefix: row?.vpa?.split("@")[0] || "",
      suffix: row?.vpa?.split("@")[1] || "",
    });

    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const [formData, setFormData] = useState({
    prefix: row?.vpa?.split("@")[0] || "",
    suffix: row?.vpa?.split("@")[1] || "",
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "end",
      }}
    >
      <Tooltip title="Edit Vpa">
        <Button
          sx={{
            display: "flex",
            alignItems: "center",
            padding: "8px",
            fontSize: "12px",
            color: "#ffffff",
            fontWeight: "700",
            borderRadius: "8px  ",
            transition: "all 0.3s ease",
            justifyContent: "center",
            background: "#00693E",
            "&:hover": {
              backgroundColor: "#122480",
            },
          }}
          onClick={handleOpen}
        >
          Edit
        </Button>
      </Tooltip>

      <Drawer open={open} onClose={handleClose} anchor="right">
        <Box sx={{ width: 400 }} className="sm_modal">
          <ModalHeader
            title="Edit Vpa"
            handleClose={handleClose}
            subtitle="Easily Update Your Information Today."
          />
          <Box
            component="form"
            id="update-vpa"
            noValidate
            autoComplete="off"
            onSubmit={EditVpaModal}
            sx={{
              "& .MuiTextField-root": { m: 2 },
            }}
          >
            <Grid container sx={{ pt: 1 }}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label="User ID"
                    value={row.user_id}
                    size="small"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label="VPA Prefix"
                    id="prefix"
                    size="small"
                    value={formData.prefix}
                    onChange={handleInputChange}
                    required
                    helperText="Example: john123"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label="VPA Suffix"
                    id="suffix"
                    size="small"
                    value={formData.suffix}
                    onChange={handleInputChange}
                    required
                    placeholder="ybl"
                    helperText="Only enter the provider name (e.g. ybl, okhdfcbank, axisbank). Do not include @."
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Box sx={{ mr: "5px" }}>
              <ModalFooter form="update-vpa" request={request} btn="Edit Vpa" />
            </Box>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
};
export default EditVpa;
